import updateMapByDirectory from "../../directory/updateMapByDirectory";

export const updateDirectory = (map, prevDirectory, newDirectory) => {
    const directoryHasChanged = JSON.stringify(prevDirectory) !== JSON.stringify(newDirectory);
    if (directoryHasChanged) updateMapByDirectory(map, newDirectory);  
}